import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import './NavMenu.less';

class NavMenu extends Component {
  state = {
    current: null,
  }

  componentDidMount() {
    this.setMenuState(this.props.history.location);
  }

  setMenuState = (location) => {
    if (location) {
      if (location.pathname.includes('/control') || location.pathname === '/') {
        this.setState({ current: 'control' });
      }
      if (location.pathname.includes('/reports')) {
        this.setState({ current: 'reports' });
      }
    }
  }

  handleClick = (e) => {
    this.setState({
      current: e.key,
    });
    this.props.history.push(e.key === 'control' ? '/' : `/${e.key}`);
  }

  render() {
    const { position } = this.props;

    return (
      <div className={classNames('nav-bar', position)}>
        <Menu
          onClick={this.handleClick}
          selectedKeys={[this.state.current]}
          mode="horizontal"
          className="nav-menu"
        >
          <Menu.Item key="control">
            Control Centre
          </Menu.Item>
          <Menu.Item key="reports">
            Reports Centre
          </Menu.Item>
        </Menu>
      </div>
    );
  }
}

NavMenu.defaultProps = {
  position: '',
};
NavMenu.propTypes = {
  history: PropTypes.object.isRequired,
  position: PropTypes.string,
};

export { NavMenu as PureNavMenu };

export default withRouter(NavMenu);



// WEBPACK FOOTER //
// ./src/components/Layout/Main/NavMenu/NavMenu.js